'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    StandardPrice: 'standardPrice',

    CatalogUnitPrice: 'catalogUnitPrice',
    CatalogUnitPriceWithoutVat: 'catalogUnitPriceWithoutVat',
    CatalogUnitPriceVat: 'catalogUnitPriceVat',

    CartTotalPrice: 'cartTotalPrice',
    CartTotalPriceWithoutVat: 'cartTotalPriceWithoutVat',
    CartTotalPriceVat: 'cartTotalPriceVat',

    OrderTotalPrice: 'orderTotalPrice',
    OrderTotalPriceWithoutVat: 'orderTotalPriceWithoutVat',
    OrderTotalPriceVat: 'orderTotalPriceVat',
    OrderUnitPrice: 'orderUnitPrice'
};


//////////////////
// WEBPACK FOOTER
// ./~/linksoft-albatros/src/PriceType.js
// module id = 464
// module chunks = 0